export const INCLUSIVE = 'INCLUSIVE';
export const EXCLUSIVE = 'EXCLUSIVE';